import * as actionsType from "../actions/types";


const initialState = {
  categories: [],
};
export default function category(state = initialState, { payload, type }) {
  let tempState = { ...state };
  switch (type) {
    case actionsType.UPDATE_CATEGORIES:
      console.log('---------yes its running')
      console.log("categories in reducer: ", payload.data);
      return { ...state, categories: payload.data };
    // case actionsType.LOGOUT_SUCCESS:
    //   console.log("Initial State on logout", initialState);
    //   return { ...initialState };



    case actionsType.ADD_CATEGORY:

      state.categories = [...state.categories, payload]
      return { ...state };

    case actionsType.EDIT_CATEGORY:
      const { editId, name, feature } = payload;
      let editIndex = state.categories.findIndex(i => i._id === editId);
      tempState.categories[editIndex].name = name;
      tempState.categories[editIndex].feature = feature;
      return { ...state, tempState };

    case actionsType.DEL_CATEGORY:
      // alert(JSON.stringify(action.payload))
      const { id } = payload;
      let index = state.categories.findIndex(i => i._id === id);
      state.categories.splice(index, 1)
      return { ...state, };

    default:
      return state;
  }
}
